import type { BadgeProps } from '@chakra-ui/react';
import { Badge, FormatNumber, Span } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface PlatformFeeInfoProps extends BadgeProps {
  amount: number;
  currency: string;
  fontSize?: string;
  fontWeight?: string;
}

/**
 * Displays a line like: Including [amount] platform's fees
 */
export const PlatformFeeInfo: React.FC<PlatformFeeInfoProps> = ({
  amount,
  currency,
  colorPalette = 'gray',
  size = 'xs',
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Badge gap={0} colorPalette={colorPalette} size={size} w="fit-content" {...props}>
      {t('payouts.platformFee.including')}
      <Span px={0.5}>
        <FormatNumber value={amount} currency={currency} style="currency" />
      </Span>
      {t('payouts.platformFee.text')}
    </Badge>
  );
};

export default PlatformFeeInfo;
